import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineTimesCircleIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M15.71 8.29a.9986.9986 0 0 0-.71-.2958 1.0003 1.0003 0 0 0-.71.2958L12 10.59l-2.29-2.3a1.004 1.004 0 1 0-1.42 1.42l2.3 2.29-2.3 2.29a.9988.9988 0 0 0-.2958.71.9994.9994 0 0 0 .2958.71.9995.9995 0 0 0 1.42 0l2.29-2.3 2.29 2.3a1 1 0 0 0 1.42 0 1.0012 1.0012 0 0 0 .2958-.71.999.999 0 0 0-.2958-.71L13.41 12l2.3-2.29a1.001 1.001 0 0 0 .2958-.71.9994.9994 0 0 0-.2958-.71Zm3.36-3.36A9.9995 9.9995 0 0 0 8.0905 2.6217 10 10 0 0 0 4.93 19.07a10.0001 10.0001 0 0 0 17.1925-7.0341 9.9993 9.9993 0 0 0-3.0525-7.106Zm-1.41 12.73a7.9998 7.9998 0 0 1-13.314-3.3266A8 8 0 1 1 20 12a7.9492 7.9492 0 0 1-2.34 5.66Z"/>
  </SvgIcon>
}

export default LineTimesCircleIcon
